import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AnimatedRoutes from '../../global/component/organism/AnimatedRoute/AnimatedRoute.tsx';
import HcpPatientDashboardShell from './HcpPatientDashboardShell.tsx';
import MedicalOverview from './Page/MedicalOverview.tsx';
import MedicalInformation from './Page/MedicalInformation.tsx';
import WrappedDosageModeling from './Page/DosageModeling.tsx';
import WrappedEditPrescriptionTable from './Table/EditPrescriptionTable.tsx';
import WrappedPhysiologicalDataTable from './Table/PhysiologicalDataTable.tsx';
import PhysiologicalForm from './Form/PhysiologicalForm.tsx';
import HcpForm from '../AdminDashboard/Form/HcpForm.tsx';
import ChangePassword from '../Login/ChangePassword/ChangePassword.tsx';
import WrappedTaskTable from '../HcpDashboard/Table/TaskTable.tsx';
import TaskForm from '../HcpDashboard/Form/TaskForm.tsx';
import Documents from './Form/DocumentForm.tsx';
import SurveyResult from '../Survey/SurveyResult.tsx';
import WrappeTherapeuticDrugMonitoringTable from './Widget/TherapeuticDrugMonitoring.tsx';
import LifeEventsForm from './Form/LifeEventForm.tsx';
import PhysicalExaminationForm from './Form/PhysicalExaminationForm.tsx';
import MedicalHistoryForm from './Form/MedicalHistoryForm.tsx';
import CounsellingNoteForm from './Form/CounsellingNoteForm.tsx';
import PatientJournals from './Page/PatientJournals.tsx';
import WrappedPatientDelegations from './Page/PatientDelegations.tsx';
import MMECalculatorTable from './Table/MMECalculatorTable.tsx';

const HcpPatientDashboardRoute: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HcpPatientDashboardShell />}>
                <Route index element={<Navigate to="medicalInformation" replace />} />
                <Route path="changePassword" element={<ChangePassword />} />
                <Route element={<AnimatedRoutes />}>
                    <Route index element={<MedicalOverview />} />
                    <Route path="main" element={<MedicalOverview />} />
                    <Route path="hcpProfile/:id" element={<HcpForm />} />
                    <Route path="medicalInformation" element={<MedicalInformation />} />
                    <Route path="dosageModeling" element={<WrappedDosageModeling />} />
                    <Route path="dosageModeling/mmeCalculator" element={<MMECalculatorTable />} />
                    <Route path="biomarkers" element={<WrappeTherapeuticDrugMonitoringTable />} />
                    <Route path="medicalInformation/editPrescription/:id" element={<WrappedEditPrescriptionTable />} />
                    <Route path="medicalInformation/documents/:id" element={<Documents />} />
                    <Route path="lifeEvents/:id" element={<LifeEventsForm />} />
                    <Route path="physicalExamination/:id" element={<PhysicalExaminationForm />} />
                    <Route path="medicalHistory/:id" element={<MedicalHistoryForm />} />
                    <Route path="counsellingNote/:id" element={<CounsellingNoteForm />} />
                    <Route path="physiologicalData" element={<WrappedPhysiologicalDataTable />} />
                    <Route path="physiologicalData/:id" element={<PhysiologicalForm />} />
                    <Route path="task" element={<WrappedTaskTable />} />
                    <Route path="task/:id" element={<TaskForm />} />
                    <Route path="surveyResult/:id" element={<SurveyResult />} />
                    <Route path="journals" element={<PatientJournals />} />
                    <Route path="delegations" element={<WrappedPatientDelegations />} />
                </Route>
                <Route path="*" element={<Navigate to="/hcpPatientDashboard/medicalInformation" replace />} />
            </Route>
        </Routes>
    );
};

export default HcpPatientDashboardRoute;
